import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
const mainActionTableButtonCss = "mulbo8n";
export const MainActionTableButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(mainActionTableButtonCss, props.className)} />);

require("./main_action_table_button.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./main_action_table_button.js");